import Router from './app/util/Router';
import common from './app/routes/common';
import home from './app/routes/home';
import productCategoriesIndex from './app/routes/productCategoriesIndex';
const routes = new Router({
    common,
    home,
    productCategoriesIndex,
});
jQuery(document).ready(() => routes.loadEvents());
